import { Palette } from '@core/theme/color-palette-siteassist'

export type TemplateWarningTypes =
  | 'IMAGE_DUPLICATE'
  | 'CLONED_PERMIT'
  | 'IMAGE_OBJECT_DETECTION'

export type TemplateWarningTriggerTypes = 'MISSING_ITEMS' | 'PRESENT_ITEMS'

export type TemplateWarningStage =
  | 'FINAL_SIGN_OFF'
  | 'AUTHORISED_PERSON'
  | 'PERMIT_HOLDER'
  | 'POST_PERMIT_CHECKS'

export type TemplateWarningItems =
  | 'ARTIFICIAL_PHOTO'
  | 'CAT_SCANNER'
  | 'FIRE_EXTINGUISHER'
  | 'GAS_CANISTER'
  | 'GENNY'
  | 'INSPECTION_TAG'
  | 'KEY'
  | 'LADDER'
  | 'LOCK'
  | 'PERSON'

export type TemplateWarningItemTypes = {
  // currently the backend only supports FIRE_EXTINGUISHER types;
  FIRE_EXTINGUISHER: Array<FireExtinguisherTypes>
} & {
  [K in Exclude<TemplateWarningItems, 'FIRE_EXTINGUISHER'>]?: Array<string>
}

export type FireExtinguisherTypes =
  | 'WATER'
  | 'FOAM'
  | 'CO2'
  | 'WET_CHEMICAL'
  | 'POWDER'

export type TempateWarningConfigType = {
  type: TemplateWarningTypes
  triggers?: Array<TemplateWarningTriggerTypes>
  // items to be deprecated, read from itemTypes instead
  items?: Array<TemplateWarningItems>
  itemTypes?: TemplateWarningItemTypes
  enabled?: boolean
}

export type DetectedObject = {
  displayName: TemplateWarningItems
  item: string
  present: boolean
  count: number
  boundingBoxes: Array<{
    probability: number
    xMin: number
    yMin: number
    xMax: number
    yMax: number
    imageWidth: number
    imageHeight: number
  }>
}

export type DetectedObjects = {
  [mediaKey: string]: Array<DetectedObject>
}

export const warningItemColors = {
  FIRE_EXTINGUISHER: {
    border: Palette.Red[500],
    background: 'rgba(255, 86, 48, 0.1)',
    label: Palette.Red[500],
  },
  LADDER: {
    border: Palette.Blue[500],
    background: 'rgba(32, 149, 243, 0.1)',
    label: Palette.Blue[500],
  },
  INSPECTION_TAG: {
    border: Palette.Green[500],
    background: 'rgba(0, 166, 105, 0.1)',
    label: Palette.Green[500],
  },
  PADLOCK: {
    border: Palette.Purple[500],
    background: 'rgba(156, 39, 176, 0.1)',
    label: Palette.Purple[500],
  },
  TECHNICAL_DRAWERS: {
    border: Palette.Cyan[500],
    background: 'rgba(0, 184, 217, 0.1)',
    label: Palette.Cyan[500],
  },
  KEYS: {
    border: Palette.Orange[500],
    background: 'rgba(255, 152, 0, 0.1)',
    label: Palette.Orange[500],
  },
  EXPOSED_REBAR: {
    border: Palette.DeepOrange[500],
    background: 'rgba(255, 87, 72, 0.1)',
    label: Palette.DeepOrange[500],
  },
  EXCAVATOR: {
    border: Palette.Yellow[800],
    background: 'rgba(255, 171, 0, 0.1)',
    label: Palette.Yellow[800],
  },
  GAS_CANISTER: {
    border: Palette.Teal[500],
    background: 'rgba(0, 150, 136, 0.1)',
    label: Palette.Teal[500],
  },
  OVERHEAD_CABLES: {
    border: Palette.Pink[500],
    background: 'rgba(233, 30, 99, 0.1)',
    label: Palette.Pink[500],
  },
  GROUND_MARKINGS: {
    border: Palette.Lime[500],
    background: 'rgba(205, 220, 57, 0.1)',
    label: Palette.Lime[500],
  },
  PERSON_WITHOUT_FULL_PPE: {
    border: Palette.Red[500],
    background: 'rgba(255, 86, 48, 0.1)',
    label: Palette.Red[500],
  },
  PERSON_WITH_FULL_PPE: {
    border: Palette.Green[500],
    background: 'rgba(0, 166, 105, 0.1)',
    label: Palette.Green[500],
  },
  SCREENSHOT_OR_PHOTO_OF_PHOTO: {
    border: Palette.Grey[500],
    background: 'rgba(158, 158, 158, 0.1)',
    label: Palette.Grey[500],
  },
  ARTIFICIAL_PHOTO: {
    border: Palette.Violet[700],
    background: 'rgba(69, 57, 181, 0.1)',
    label: Palette.Violet[700],
  },
  ALL_ITEMS: {
    border: Palette.Amber[500],
    background: 'rgba(255, 193, 7, 0.1)',
    label: Palette.Amber[500],
  },
}
